import { combineReducers } from '@reduxjs/toolkit'

import {
  DELETE_TEMPLATE_REDUCER_NAME,
  TEMPLATES_LIST_REDUCER_NAME,
} from './consts'
import { deleteTemplateReducer, templatesListReducer } from './slice'

export default combineReducers({
  [TEMPLATES_LIST_REDUCER_NAME]: templatesListReducer,
  [DELETE_TEMPLATE_REDUCER_NAME]: deleteTemplateReducer,
})
